module.exports = __webpack_public_path__ + "static/milestone1-93b2dd5c82038eb35ca62a08a372272f.png";